if (!customElements.get('policy-modal-opener')) {
  const isPlainClick = (event, link) =>
    !(
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      link.hasAttribute('download') ||
      (link.target && link.target !== '_self')
    );

  class PolicyModalOpener extends HTMLElement {
    constructor() {
      super();

      const link = this.querySelector('a');
      if (!link) return;

      link.addEventListener('click', (event) => {
        if (!isPlainClick(event, link)) return;

        const modal = document.querySelector(this.dataset.modal);
        if (!modal) return;

        event.preventDefault();

        let focusTarget = link;
        const drawer = this.closest('header-drawer');
        if (drawer) {
          const summary = drawer.querySelector(':scope > details > summary');
          if (summary) {
            drawer.closeMenuDrawer(event, summary);
            focusTarget = summary;
          }
        }

        modal.show(focusTarget);
      });
    }
  }

  customElements.define('policy-modal-opener', PolicyModalOpener);

  /* 本文中（リッチテキスト）の /policies/〇〇 へのリンク */
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || link.closest('policy-modal-opener') || !isPlainClick(event, link)) return;
    if (link.origin !== location.origin) return;

    const match = link.pathname.match(/^\/policies\/([^/]+)\/?$/);
    if (!match) return;

    const modal = document.getElementById(`PolicyModal-${match[1]}`);
    if (!modal || typeof modal.show !== 'function') return;

    event.preventDefault();

    /* 規約モーダル内のリンク＝重ねずに差し替え、閉じたときは元の起点へ戻す */
    const current = link.closest('modal-dialog');
    if (current === modal) return;
    if (current) {
      const opener = current.openedBy;
      current.hide();
      modal.show(opener || link);
      return;
    }

    modal.show(link);
  });
}
